<template>
  <v-toolbar flat class heigh0="80px" style="background:linear-gradient(90deg, rgb(236, 236, 236), rgb(255, 255, 255));position:absolute;">
    <v-toolbar-title v-text="title" class="view-title"></v-toolbar-title>
    <v-spacer></v-spacer>

    <span v-if="isUserLoggedIn()" class="mr-3 chars-title">
      WORDS LEFT:
      <span class="white--text chars-value pa-1">{{userCharactersLeft}}</span>
    </span>
    <v-btn color="grey darken-2" class="toolbar-button" flat to="/app/pricing">Pricing</v-btn>
    <v-btn color="grey darken-2" class="toolbar-button" flat to="/app/gallery">Samples Gallery</v-btn>
    <v-btn
      v-if="!isUserLoggedIn()"
      color="pink darken-2"
      class="toolbar-button"
      flat
      @click="login()"
      id="signInButton"
    >
      <v-icon left>arrow_right</v-icon>Sign In
    </v-btn>

    <v-menu v-if="isUserLoggedIn()" offset-y>
      <v-btn slot="activator" color="#6b6b6b" icon flat>
        <v-icon>person_outline</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile to="/app/profile">
          <v-list-tile-title>User Profile</v-list-tile-title>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-title>Delete Account</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <!--
      <v-tooltip bottom>
      <v-btn slot="activator" color="#6b6b6b" icon flat>
        <v-icon>person_outline</v-icon>
      </v-btn>
        <span>User Profile</span>
      </v-tooltip>
    -->

    <v-tooltip bottom v-if="isUserLoggedIn()">
      <v-btn slot="activator" color="#6b6b6b" icon flat @click="logout()">
        <v-icon>power_settings_new</v-icon>
      </v-btn>
      <span>Logout</span>
    </v-tooltip>
  </v-toolbar>
</template>

<style scoped>
#signInButton i {
  margin-right: 0px !important;
}

.toolbar-button {
  font-weight: 400;
}

.view-title {
  font-weight: normal;
  position: relative;
  left: 300px;
}

.chars-title {
  --color: #2196f3;
}

.chars-value {
  border-radius: 4px;
  background: #24d0da;
}
</style>

<script>
import { Auth } from "./auth/cognito_auth";
import UserQuotaService from "../service/userQuotaService";

export default {
  name: "lingo_toolbar",
  data() {
    return {
      e1: 0,
      miniVariant: false,
      title: null,
      userCharactersLeft: "?"
    };
  },
  watch: {
    $route(val) {
      this.title = val.name;
    }
  },
  methods: {
    logout() {
      Auth.logout();
    },
    loadUserCharacters() {
      var that = this;
      UserQuotaService.getUserCharactersLeft().then(function(response) {
        that.$store.commit(
          "setUserCharactersLeft",
          response.data.charactersBalance
        );
      });
    },
    isUserLoggedIn() {
      return Auth.isUserLoggedIn();
    },
    login() {
      Auth.login();
    }
  },
  mounted() {
    // hide if user not logged in
    var that = this;

    this.$store.subscribe(mutation => {
      if (mutation.type == "setUserCharactersLeft") {
        that.userCharactersLeft = mutation.payload;
      }
    });

    this.$root.$on("refreshUserCharacters", () => {
      that.loadUserCharacters();
    });

	if (this.isUserLoggedIn()) {
	    this.loadUserCharacters();
	}
  }
};
</script>


